module.exports = __webpack_public_path__ + "static/scenario-offer-example.en-84efdae9c312fd0e8d3684be74acd074.png";